import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from 'src/Resources/Images/extensions/powerFixAndPowerShare.svg'

const Ai360ExtensionsLogo: React.FC<SvgIconProps> = props => (
  <SvgIcon viewBox={'0 0 160 36'} component={Icon} sx={{ width: 160, height: 36 }} {...props} />
)

export default Ai360ExtensionsLogo
